<template>
    <div class="hk-button" :style="{ width: customStyle.width }">
        <p
            class="hk-button_inner"
            :style="{
                width: customStyle.width,
                color: customStyle.color,
                boxShadow: `0px 5px 18px 0px ${customStyle.shadowColor}`,
                border: customStyle.border,
                background: customStyle.background
                    ? `linear-gradient(-3deg, ${customStyle.startColor}, ${customStyle.endColor})`
                    : 'transparent',
                height: height + 'px',
                borderRadius: `${height / 2}px`,
                fontSize: fontSize + 'px'
            }"
            @click="handleClick"
        >
            {{ text }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'HkButton',
    props: {
        text: {
            require: true,
            type: String
        },
        customStyle: {
            type: Object,
            default: () => {
                return {
                    width: '110px',
                    color: '#6D33B3',
                    border: 'none',
                    shadowColor: 'transparent',
                    background: false
                };
            }
        },
        height: {
            type: Number,
            default: 40
        },
        fontSize: {
            type: Number,
            default: 16
        }
    },
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {
        handleClick() {
            this.$emit('handleClick');
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.hk-button_inner {
    box-sizing: border-box;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    cursor: pointer;
    user-select: none;
}
</style>
